import { render } from "./VueSplash.vue?vue&type=template&id=2cbd6df7&scoped=true"
import script from "./VueSplash.vue?vue&type=script&lang=js"
export * from "./VueSplash.vue?vue&type=script&lang=js"

import "./VueSplash.vue?vue&type=style&index=0&id=2cbd6df7&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbd6df7"]])

export default __exports__